import { render, staticRenderFns } from "./DentistAssociate.vue?vue&type=template&id=06e8e32a&scoped=true"
import script from "./DentistAssociate.vue?vue&type=script&lang=js"
export * from "./DentistAssociate.vue?vue&type=script&lang=js"
import style0 from "./DentistAssociate.vue?vue&type=style&index=0&id=06e8e32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e8e32a",
  null
  
)

export default component.exports